'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _inputsStyles = require('../inputsStyles/inputsStyles');
var _wavfichacertaFichacertaSharedStyles = require('@bit/wavfichacerta.fichacerta.shared-styles.columns');
var _wavfichacertaFichacertaSharedStyles2 = require('@bit/wavfichacerta.fichacerta.shared-styles.rows');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ActionButtonForm = function (_PureComponent) {
  _inherits(ActionButtonForm, _PureComponent);
  function ActionButtonForm() {
    _classCallCheck(this, ActionButtonForm);
    return _possibleConstructorReturn(this, (ActionButtonForm.__proto__ || Object.getPrototypeOf(ActionButtonForm)).apply(this, arguments));
  }
  _createClass(ActionButtonForm, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_wavfichacertaFichacertaSharedStyles.BaseColumn, {
        'data-testid': 'ActionButtonForm',
        className: this.props.size
      }, _react2.default.createElement(_wavfichacertaFichacertaSharedStyles.BaseColumn, {
        style: {
          padding: 0,
          marginBottom: '.5rem',
          marginTop: '1.5rem'
        }
      }, _react2.default.createElement('div', {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, _react2.default.createElement(_inputsStyles.StyledLabel, null, this.props.label))), _react2.default.createElement(_wavfichacertaFichacertaSharedStyles2.StyledRow, null, _react2.default.createElement(_inputsStyles.ActionButton, {
        type: 'button',
        onClick: this.props.onClick
      }, this.props.value)));
    }
  }]);
  return ActionButtonForm;
}(_react.PureComponent);
exports.default = ActionButtonForm;